import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { SUMMARY_EVENT_KEY } from './keys';
import { EnrollApi } from 'api';
import { IEnrollSummary } from 'types';

function useGetSummaryByEvent(id: string) {
  return useAuthQuery(
    getQueryKeys(SUMMARY_EVENT_KEY).detail(id),
    () => EnrollApi.getSummaryByEvent(id),
    {
      enabled: !!id,
      select: (data) => data.data as IEnrollSummary | undefined,
    },
  );
}

export default useGetSummaryByEvent;
